import styled from 'styled-components';

export const ConclusionContainer = styled.div`
  background-color: var(--allie-color-neutral-10);
  border-radius: var(--allie-radius-md);
  padding: var(--allie-spacing-lg) var(--allie-spacing-xl);
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-sm);
`;

export const EmptyConclusionText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--allie-spacing-md);
`;

export const EmptyConclusionCardContent = styled.div`
  display: flex;
  flex: 1 0 0;
  gap: var(--allie-spacing-xl);
`;

export const EmptyConclusionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-md);

  ion-card {
    margin: 0;
    box-shadow: var(--allie-shadow-md);
  }
`;

export const EmptyConclusionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: var(--allie-radius-sm);
  background-color: var(--allie-color-neutral-60);
  color: var(--allie-color-white);
`;
